// removed by extract-text-webpack-plugin
module.exports = {"counter-btn":"Counter__counter-btn","counterBtn":"Counter__counter-btn","counter-btn-active":"Counter__counter-btn-active","counterBtnActive":"Counter__counter-btn-active","counter-btn-disable":"Counter__counter-btn-disable","counterBtnDisable":"Counter__counter-btn-disable","icon-sizem":"Counter__icon-sizem","iconSizem":"Counter__icon-sizem","counter-number":"Counter__counter-number","counterNumber":"Counter__counter-number","container":"Counter__container","backgroundIcon":"Counter__backgroundIcon","backgroundIconFont":"Counter__backgroundIconFont"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Counter/Counter.css
// module id = 1126
// module chunks = 8